export default __webpack_public_path__ + "static/media/Matched.09784ddf.svg";